import {
  Component,
  ElementRef,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { CignaIconComponent } from '../../../shared/components/cigna-icon/cigna-icon.component';
import { UtilsService } from '../../../shared/services/utils.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-marquee',
  templateUrl: './marquee.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CignaIconComponent, NgClass],
})
export class MarqueeComponent {
  @Input() text = '';

  private _utilsService = inject(UtilsService);

  isIOS: boolean = false;

  constructor(
    private hostRef: ElementRef<HTMLElement>,
    private cd: ChangeDetectorRef
  ) {
    this.isIOS = this._utilsService.isApp() && this._utilsService.isIOS();
  }
}
